import { Form } from '@/hooks/use-form-field';
import { convertEmptyStringsToNull } from '@/schemas/converters';
import { FormProps, FormValues } from '@/constants/formTypes';
import { DynamicRenderer } from './DynamicRenderer';
import useDynamicForm from '@/hooks/use-dynamic-form';

export function DynamicForm({ formData, onSubmit, route }: FormProps) {
  const validateOnMount = 'validate_on_mount' in formData && formData.validate_on_mount === true;
  const validationMode = 'validation_mode' in formData ? formData.validation_mode : undefined;
  const form = useDynamicForm(formData.components, { validateOnMount, validationMode });

  function handleFormSubmit(data: FormValues) {
    const convertedData = convertEmptyStringsToNull(data);

    void onSubmit(convertedData);
  }

  return (
    <Form {...form}>
      <form
        onSubmit={(ev) => void form.handleSubmit(handleFormSubmit)(ev)}
        id={formData.id ?? ''}
      >
        <DynamicRenderer
          form={form}
          components={formData.components}
          route={route}
          submit={handleFormSubmit}
        />
      </form>
    </Form>
  );
}
